import { useQuery } from '@tanstack/react-query'
import { reqApiAgentCurrencyGetSysCurrency, reqApiAgentCurrencyListAll } from '@/apis/ok'
import { useUserStore } from '@/store/user/useUserStore'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function useCurrency() {
  const { i18n } = useTranslation()
  const token = useUserStore((state) => state.token)

  const { data: currencyList } = useQuery({
    queryKey: ['currencyList', token, i18n.language],
    queryFn: () => reqApiAgentCurrencyListAll(),
    enabled: !!token,
  })

  const { data: currentCurrency } = useQuery({
    queryKey: ['currentCurrency', token, i18n.language],
    queryFn: () => reqApiAgentCurrencyGetSysCurrency(),
    enabled: !!token,
  })

  const currencySign =
    useMemo(() => {
      return currencyList?.rows.find((item) => item.currency === currentCurrency?.t)?.sign
    }, [currencyList, currentCurrency]) || null

  // 取得所有币别
  const currencyListAll = useMemo(() => {
    return currencyList?.rows || []
  }, [currencyList])

  return {
    currencySign,
    currencyListAll,
    currentCurrencyName: currentCurrency?.t || 'PHP',
  }
}
